import { Paper } from "@mui/material";
import styled from "@emotion/styled";

export const SkeletonCardWrapper = styled(Paper)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	padding: "16px",
	gap: "16px",
	backgroundColor: theme.project.colors.allColors.hex.grayscale.gray50,
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const SkeletonHeader = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	"& > *": {
		height: "24px"
	},
	[theme.breakpoints.down("md")]: {
		"& > *": {
			height: "36px"
		}
	}
}));

export const SkeletonDetails = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "5fr 3fr 3fr 2fr 1fr 1fr",
	gap: "24px",
	alignItems: "center",
	width: "100%",
	"& > *": {
		height: "36px"
	},
	[theme.breakpoints.down("md")]: {
		gap: "16px",
		gridTemplateColumns: "1fr",
		"& > *": {
			height: "24px"
		}
	}
}));

export const SkeletonWrapper = styled.div({
	display: "flex",
	flexDirection: "column",
	flexWrap: "wrap",
	gap: "16px",
	width: "100%"
});
